export const TableActionStyle = { minWidth: 60, fontSize: 12, padding: 4 };
